import { render, staticRenderFns } from "./IconCloseBlue.vue?vue&type=template&id=1adcaf4d&scoped=true"
import script from "./IconCloseBlue.vue?vue&type=script&lang=js"
export * from "./IconCloseBlue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adcaf4d",
  null
  
)

export default component.exports